<template>
    <b-modal size="lg" ref="modalAssocia" id="modalAssociaUtente" title="Associa Utente" @show="onShow()" scrollable>
        <b-form @submit.prevent="onSubmitUsers">
            <b-row>
                <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                    <b-form-input v-model="mdlFiltroUsers.username" type="search" placeholder="Username"></b-form-input>
                </b-col>

                <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                    <b-form-select v-model="mdlFiltroUsers.profilo" :options="profiliModalOptions" :value="null" value-field="value" text-field="text"></b-form-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="sa-padding-right text-right">
                    <b-button type="submit" variant="info">Cerca</b-button>
                </b-col>
            </b-row>
        </b-form>
        <div class="b-table-sticky-header">
            <b-table sticky-header :busy="isBusy" ref="table" selectable stacked="lg" striped hover :items="itemsUtenti" :fields="fieldsModal" sort-icon-left head-variant="light" class="sa-b-table" current-page="1" :per-page="perPageUsers" @row-selected="onRowSelected">
                <template #table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Caricamento...</strong>
                    </div>
                </template>
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                    </template>
                </template>
                <template #cell(firstname)="row">
                    <p>{{ row.item.lastname }} {{ row.item.firstname }}</p>
                </template>
            </b-table>
        </div>

        <template #modal-footer="{ ok }">
            <b-button size="sm" variant="outline-danger" @click="ok()">
                <b-icon icon="x"></b-icon>
                Annulla
            </b-button>
            <b-button size="sm" variant="outline-success" @click="onAssocia()">
                <b-icon icon="person-check-fill"></b-icon>
                Associa
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    components: {},
    props: {
        associatedUsers: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        rows() {
            return this.items.length;
        },
    },
    mixins: [UtilityMixin],
    data() {
        return {
            isBusy: false,
            showModalLoading: false,
            perPage: 10,
            perPageUsers: 100000,
            currentPage: 1,
            currentPageUsers: 1,
            pathResource: "/rsalaboratorirepartiutenti",
            pathResourceUtenti: "/users",
            pathResourceGruppiUtenti: "/gruppi",
            linkedit: null,
            pathRESTRequest: "/ambulatorio",
            mdlFiltroUsers: {
                profilo: "",
                username: "",
            },
            selected: [],
            profiliModalOptions: [],
            filterOn: [],
            jsonData: {},
            items: [],
            reparto: {},
            itemsUtenti: [],
            filtroUsers: { forPage: 0, page: 0, user: "", profilo: "" },

            fieldsModal: [
                {
                    label: "",
                    key: "selected",
                    thStyle: "width: 2.5rem",
                    tdClass: "text-center",
                },
                {
                    label: "Username",
                    key: "username",
                    sortable: true,
                    thStyle: "width: 8rem",
                },
                {
                    label: this.getLabelTraduora("patients.lblNominative"),
                    key: "firstname",
                    sortable: true,
                    thStyle: "width: 8rem",
                },
                {
                    label: "Tipo Operatore",
                    key: "profilo",
                    sortable: true,
                    thStyle: "width: 8rem",
                },
            ],
        };
    },
    created: function () {},
    // mounted: function () {
    //     let me = this;
    //     me.idPresidio = this.$route.params.id;
    //     me.loadDefaultData();
    // },
    methods: {
        init(item) {
            let me = this;
            me.reparto = item;
            me.loadDefaultData();
            me.show();
        },
        getId(obj) {
            return obj.idUtente;
        },
        show() {
            let me = this;
            me.$refs.modalAssocia.show();
        },
        loadDataUtenze() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceUtenti;
            me.showModalLoading = true;
            me.filtroUsers.forPage = me.perPageUsers;
            me.filtroUsers.page = me.currentPageUsers;
            me.filtroUsers.username = me.mdlFiltroUsers.username;
            me.filtroUsers.profilo = me.mdlFiltroUsers.profilo;
            axios
                .get(link, { params: me.filtroUsers })
                .then((response) => {
                    me.isBusy = false;
                    me.showModalLoading = false;
                    me.itemsUtenti = response.data.data.list;
                    let list = response.data.data.list;
                    let associatedIds = new Set(me.associatedUsers.map((u) => me.getId(u)).filter(Boolean));
                    me.itemsUtenti = list.filter((element) => {
                        let id = element.id;
                        return !associatedIds.has(id);
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        loadDefaultData() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceGruppiUtenti;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((element) => {
                        me.profiliModalOptions.push({ text: element.nome, value: element.nome });
                    });
                })
                .finally(() => {
                    me.profiliModalOptions.unshift({ text: this.getLabelTraduora("patient.ecoreferting.lblSelected"), value: "" });
                });
        },

        onRowSelected(items) {
            this.selected = items;
            // console.log(items);
        },
        onAssocia() {
            let me = this;
            for (let i = 0; i < me.selected.length; i++) {
                let obj = { id: null, codiceReparto: me.reparto.codiceReparto, idUtente: me.selected[i].id };
                me.associaUtenteReparto(obj);
            }
        },
        associaUtenteReparto(obj) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
            axios
                .post(link, { codiceReparto: obj.codiceReparto, idUtente: obj.idUtente })
                .then((response) => {
                    me.$emit("afterAssociazione");
                    me.$refs["modalAssocia"].hide();
                    response.data.data;
                    me.showModalLoading = false;

                    this.$bvToast.toast(`${this.getLabelTraduora("ambulatory.toastAssociateUser") + " " + me.jsonData.nome}`, {
                        title: this.getLabelTraduora("ambulatory.toastAssociateUserSuccess"),
                        solid: true,
                        variant: "success",
                        autoHideDelay: 1000,
                        appendToast: true,
                    });
                })
                .catch((e) => {
                    console.log(e);
                    me.showModalLoading = false;
                });
        },
        ok() {},
        // onDeleteAssociazione(item) {
        //     let me = this;
        //     this.$bvModal
        //         .msgBoxConfirm(this.getLabelTraduora("ambulatory.modelMessageConfirmDeleteAssociate"), {
        //             title: this.getLabelTraduora("ambulatory.modelMessageDeleteAssociate"),
        //             buttonSize: "sm",
        //             okVariant: "secondary",
        //             cancelVariant: "danger",
        //             okTitle: "SI",
        //             cancelTitle: "NO",
        //             footerClass: "p-2",
        //             hideHeaderClose: false,
        //             centered: true,
        //         })
        //         .then((value) => {
        //             if (value) {
        //                 me.deleteAssociazione(item);
        //             }
        //         })
        //         .catch((error) => {
        //             console.log(error);
        //         });
        // },
        deleteAssociazione(item) {
            let me = this;
            // console.log(item);

            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
            axios
                .delete(link + item.id)
                .then((response) => {
                    response;
                    me.$emit("afterAssociazione");
                    me.showModalLoading = false;
                    // me.loadData();
                })
                .catch((error) => {
                    console.log(error);
                    me.showModalLoading = false;
                });
        },
        onShow() {
            let me = this;
            me.loadDataUtenze();
        },
        onResetFiltro() {
            let me = this;
            me.filtroModal.profilo = "";
            me.filtroModal.username = "";
            me.loadDataUtenze();
        },
        onFiltra() {
            let me = this;
            me.loadDataUtenze();
            // me.showModalLoading = true;
            // console.log(me.filtroModal.profilo);
            // let link = process.env.VUE_APP_PATH_API + me.pathResourceUtenti + "?user=" + me.filtroModal.username + "&profilo=" + me.filtroModal.profilo;
            // console.log(link);
            // axios.get(link).then((response) => {
            //     me.showModalLoading = false;
            //     me.itemsUtenti = response.data.data;
            // });
        },
        onSubmitUsers() {
            let me = this;
            me.loadDataUtenze();
        },
    },
};
</script>
